<ng-container *ngIf="personCount$ | async as personCount">
  <ng-template #fullPageRef>
    <ng-container *ngIf="loadingState$ | async as loadingState">
      <button
        #openButtonRef
        (click)="isBasketOpen = loadingState === 'loaded' && !isBasketOpen; didJustOpen = isBasketOpen"
        (keyup.escape)="isBasketOpen = false"
        [attr.aria-expanded]="isBasketOpen"
        [class.container-is-open]="isBasketOpen"
        [class.loading]="loadingState === 'loading'"
        [class.scrolled]="isScrolled$ | async"
        class="container"
      >
        <p class="body-4 total-text">
          <span *ngIf="isBasketOpen; else basketClosed">
            <dap-lib-scroll-lock></dap-lib-scroll-lock>
            <ng-container *ngIf="personCount === 1; else totalAllText">
              {{ 'BASKET.TOTAL_PRICE_FOR_ONE' | translate }}
            </ng-container>
          </span>
          <ng-template #basketClosed>
            <ssc-single-person-item
              *ngIf="activePerson$ | async as activePerson; else totalAllText"
              [basketIsOpen]="isBasketOpen"
              [person]="activePerson"
            ></ssc-single-person-item>
          </ng-template>
        </p>

        <ng-template #totalAllText>
          {{ 'BASKET.TOTAL_PRICE_FOR_ALL' | translate }}
        </ng-template>

        <div class="container-content-right">
          <div class="price-container">
            <p class="body-4 rate">
              {{ 'BASKET.CURRENCY_PER_MONTH' | translate }}
            </p>
            <p [attr.aria-hidden]="loadingState === 'loading'" class="price">
              <ssc-price
                *ngIf="loadingState === 'loaded'; else placeholder"
                [price]="(isBasketOpen ? openBasketPrice$ : closedBasketPrice$) | async | nullToUndefined"
                data-cy="basket-price"
              ></ssc-price>
              <ng-template #placeholder>&nbsp;</ng-template>
            </p>
          </div>

          <div *ngIf="loadingState === 'loading'" class="loader">
            <dap-lib-loader size="small"></dap-lib-loader>
          </div>

          <dap-lib-icon
            *ngIf="loadingState === 'loaded'"
            [name]="isBasketOpen ? 'arrow-sm-up' : 'arrow-sm-down'"
            iconColor="red"
            iconSize="16"
          ></dap-lib-icon>
        </div>
      </button>

      <div [class.show]="isBasketOpen" id="fade-in">
        <div class="scrollable-container">
          <ssc-basket-accordion
            (personClick)="goToInsurance($event)"
            (removeBasicInsuranceClick)="removeBasicInsurance($event)"
            (removeSupplementaryInsuranceClick)="removeSupplementaryInsurance($event)"
            [activePersonId]="activePersonId$ | async | nullToUndefined"
            [isTupCustomer]="isTupCustomer$ | async"
          ></ssc-basket-accordion>

          <div class="footer-buttons">
            <dap-lib-button
              (click)="goToPersons()"
              [buttonSize]="'small'"
              [buttonTabIndex]="isBasketOpen ? 0 : -1"
              [variant]="'tertiary'"
              data-analytics="basket_navigate-to-persons"
              data-cy="navigate-to-persons"
              iconName="pen"
              iconPosition="left"
            >
              {{ 'BASKET.NAVIGATE_TO.PERSONS' | translate }}
            </dap-lib-button>
          </div>
        </div>

        <dap-lib-button
          (click)="goToSummary()"
          [buttonSize]="'basket'"
          [buttonTabIndex]="isBasketOpen ? 0 : -1"
          [variant]="'primary'"
          data-analytics="basket_navigate-to-offer"
          data-cy="navigate-to-offer"
        >
          {{ 'BASKET.NAVIGATE_TO.OFFER' | translate }}
        </dap-lib-button>
      </div>
    </ng-container>
  </ng-template>

  <ng-template *ngIf="!isBasketOpen" [ngTemplateOutlet]="fullPageRef"></ng-template>
  <div (keyup.escape)="isBasketOpen = false" *ngIf="isBasketOpen" dapLibFocusTrap>
    <dap-lib-overlay-backdrop (click)="isBasketOpen = false" *ngIf="isBasketOpen"></dap-lib-overlay-backdrop>
    <div class="button-container">
      <ng-template [ngTemplateOutlet]="fullPageRef"></ng-template>
    </div>
  </div>
</ng-container>
